import React, { useMemo } from 'react';
import { PiStudent } from 'react-icons/pi';
import { Link, useNavigate } from 'react-router-dom';
import { MedalContainer } from '@/components/custom/medal';
import AccuracyRateTag from '../AccuracyRateTag';
import { Badge } from '@/components/ui/badge';
import { PlayfulCardButton } from '@/components/custom/playful-card';

function accuracyBadgeVariant(value) {
  if (value <= 33.33) return 'danger-soft';
  if (value <= 66.66) return 'amber-soft';
  return 'success-soft';
}

export default function ChallengeRow(props) {
  const { playful = false, index, total, challenge } = props;
  const navigate = useNavigate();

  const availabilityBody = useMemo(() => {
    let availability = [];
    if (challenge.classrooms?.length > 0) {
      availability = challenge.classrooms;
    } else if (challenge.courses?.length > 0) {
      availability = challenge.courses;
    } else if (challenge.institutions?.length > 0) {
      availability = challenge.institutions;
    }

    return availability;
  }, [challenge]);

  const accuracyRate = challenge?.['accuracy-rate'] ?? 0;

  return (
    <tr className={total === index + 1 ? 'round-dg__row round-dg__row--last' : 'round-dg__row'}>
      <td className="round-dg__cell-header round-dg__cell-header--sm round-dg__cell-header--row">
        <div className="round-dg__user">
          <div className="round-dg__user-inner">
            <h3
              className="round-dg__title"
              style={{ fontSize: 14 }}
              title={challenge.title}
            >
              {challenge.title}
            </h3>
          </div>
        </div>
      </td>
      <td className="round-dg__cell round-dg__cell--sm">
        {playful ? (
          <Badge
            variant="info-soft"
            size="sm"
            className="text-sm"
            title={challenge.taxonomy.name}
          >
            {challenge.taxonomy.name}
          </Badge>
        ) : (
          <span
            className="badge badge--tiny badge--primary"
            style={{ fontSize: 14 }}
            title={challenge.taxonomy.name}
          >
            {challenge.taxonomy.name}
          </span>
        )}
      </td>
      <td className="round-dg__cell round-dg__cell--sm">
        {challenge['initial-date'].toLocaleDateString('pt-br', { day: 'numeric' })} a {challenge['end-date'].toLocaleDateString('pt-br')}
      </td>
      <td className="round-dg__cell round-dg__cell--sm">
        <div
          className="card__badges card__badges--one-line mb-0"
          style={{ lineHeight: 1, alignItems: 'center' }}
        >
          {availabilityBody.length > 1 ? (
            <>
              <span
                className="u-text-truncate"
                title={availabilityBody[0].name ?? availabilityBody[0].title}
              >
                {availabilityBody[0].name ?? availabilityBody[0].title}
              </span>
              <span
                className="badge badge--tiny badge--more"
                style={{ fontSize: 14 }}
                title={availabilityBody?.slice(1).map(item => item.name ?? item.title)}
              >
                +{availabilityBody?.slice(1).length}
              </span>
            </>
          ) : availabilityBody.length === 1 ? (
            <span
              className="u-text-truncate"
              title={availabilityBody[0].name || availabilityBody[0].title}
            >
              {availabilityBody[0].name || availabilityBody[0].title}
            </span>
          ) : (
            <span
              className="u-text-truncate"
              title={'Público'}
            >
              Público
            </span>
          )}
        </div>
      </td>
      <td className="round-dg__cell round-dg__cell--sm">
        <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <MedalContainer value={<PiStudent />} />
          <span
            className="u-text-truncate"
            title={`${challenge?.['participation-count']} (${challenge['participants-percentage']}%)`}
          >
            {challenge?.['participation-count']} ({challenge['participants-percentage']}%)
          </span>
        </span>
      </td>
      <td className="round-dg__cell round-dg__cell--sm">
        {playful ? (
          <Badge
            variant={accuracyBadgeVariant(accuracyRate)}
            size="sm"
            className="text-sm"
            title={`${accuracyRate}%`}
          >
            {accuracyRate}%
          </Badge>
        ) : (
          <AccuracyRateTag value={challenge?.['accuracy-rate']} />
        )}
      </td>
      {playful ? (
        <td
          className="round-dg__cell"
          style={{ width: 152, paddingLeft: 8, paddingRight: 20 }}
        >
          <div className="flex justify-center">
            <PlayfulCardButton
              className="h-9 w-auto px-6"
              onClick={() => navigate(`/desafio-da-semana/resultados/${challenge.id}`)}
            >
              Detalhes
            </PlayfulCardButton>
          </div>
        </td>
      ) : (
        <td className="round-dg__cell round-dg__cell--sm">
          <Link
            className="btn btn--full btn--outline"
            to={`/desafio-da-semana/resultados/${challenge?.id}`}
          >
            Detalhes
          </Link>
        </td>
      )}
    </tr>
  );
}
